angular.module('unica_event.event_controllers', [])

.controller('EventBasicController',
	function(
		$rootScope, $scope, $stateParams, $state,
		$uibModal,
		EVENT_TYPES,
		LocationListService, UserListService
	) {

	$scope.forms = {};

	$scope.eventTypes = EVENT_TYPES;

	$scope.locations = [];

	$scope.loadLocations = function() {
		LocationListService
			.fullList()
			.then(function(data) {
				$scope.hideLoader();
				if (!data.error) {
					$scope.locations = data;
				} else {
					$rootScope.manageError(data);
				}
			});
	};


	$scope.addStage = function() {

		$rootScope.eventData.stages.push({
			from_date: '',
			to_date: '',
			// location: {
			// 	id: '',
			// 	name: ''
			// },
			location: undefined,

			// Datepickers
			dp_from: false,
			dp_to: false
		});

	};

	$scope.removeStage = function(index) {
		$rootScope.eventData.stages.splice(index, 1);
	};

	$scope.openStageDatepicker = function(index, type) {
		$rootScope.eventData.stages[index][type] = true;
	};

	$scope.dp_closingVotation = false;
	$scope.openClosingVotationDatepicker = function() {
		$scope.dp_closingVotation = true;
	};
	$scope.closeClosingVotationDatepicker = function() {
		$scope.dp_closingVotation = false;
	};

	$scope.changeDateStageHandler = function (index) {
		var fromDate = $rootScope.eventData.stages[index].from_date,
			toDate = $rootScope.eventData.stages[index].to_date;

		if ( fromDate && toDate ) {
			$scope.forms.event_form['stages_' + index + '_from_date'].$setValidity('$valid',
				fromDate.getTime() <= toDate.getTime()
			);

			$scope.forms.event_form['stages_' + index + '_to_date'].$setValidity('$valid',
				toDate.getTime() >= fromDate.getTime()
			);

			if ( fromDate.getTime() <= toDate.getTime() ||
				toDate.getTime() >= fromDate.getTime() ) {
				$scope.forms.event_form.$invalid = true;
			}
		}
	};



	/**
	 * FUNCTIONS FOR PREPARING THE STAGES DATES AND CHECKING STAGES VALIDATION
	 */
	$scope.parseDatesFromDateToTimestamp = function(stages) {
		if ( stages.length > 0 ) {
			var i = 0;
			for ( ; i < stages.length; i++ ) {
				stages[i].from_date = moment( stages[i].from_date ).format('YYYY-MM-DD');
				stages[i].from_time = moment( stages[i].from_time ).format('HH:mm:ss');
				stages[i].to_date   = moment( stages[i].to_date ).format('YYYY-MM-DD');
				stages[i].to_time   = moment( stages[i].to_time ).format('HH:mm:ss');


			}
		}
		return stages;
	};


	$scope.checkFormStages = function(index) {
		if ( $scope.forms.event_form['stages_' + index + '_to_date'].$invalid &&
			($scope.forms.event_form['stages_' + index + '_to_date'].$dirty || $scope.forms.event_form['stages_' + index + '_to_date'].$touched)
			) {
			return true;
		}
		return false;
	};


	/**
	 * FUNCTIONS FOR IMAGES UPLOAD
	 */

	$scope.changeEventCover = function() {
		$rootScope.eventData.cover_changed = true;
	};

	$scope.changeEventLogo = function() {
		$rootScope.eventData.logo_changed = true;
	};


	/**
	 * OPEN LOCATION MODAL
	 */
	$scope.openLocationModal = function ($index) {
		var modalInstance = $uibModal.open({
			ariaLabelledBy: 'modal-title',
			ariaDescribedBy: 'modal-body',
			controller: 'ModalLocationInstanceController',
			controllerAs: '$ctrl',
			templateUrl: './templates/modals/location.html',
			size: 'lg',
			windowClass: 'modal-location'
		});

		modalInstance.result.then(function (data) {
			$scope.locations.push(data);

			$rootScope.eventData.stages[$index].location_id = data.id;
			$rootScope.eventData.stages[$index].location = {
				id: data.id,
				address: data.address,
				latitude: data.latitude,
				longitude: data.longitude,
				name: data.name
			};

		}, function () { });
	};


	/**
	 * FUNCTIONS FOR AUTOCOMPLETE LOCATION
	 */

	$scope.searchLocationText = '';

	$scope.searchLocation = function(query) {

		return LocationListService
					.search(query)
					.then(function(locations) {
						if ( locations ) {
							return locations;
						}
						return [];
					});
	};

	$scope.selectedLocation = function(index, location) {
		$rootScope.eventData.stages[index].location_id = location ? location.id : undefined;
	};


	/**
	 * FUNCTIONS FOR AUTOCOMPLETE HOSTESS
	 */

	$scope.searchHostessText = '';

	$scope.searchHostess = function(query) {
		return UserListService
					.listByRoleAndSearch( 'service', 'hostess', query)
					.then(function(users) {
						if ( users ) {
							return users;
						}

						return [];
					});
	};

	$scope.selectedHostess = function(index, hostess) {
		$rootScope.eventData.stages[index].hostess_id = hostess.id;
	};

	$scope.transformChip = function(chip) {
		return chip;
	}

	$scope.updateStateYear = function () {
		// YEARS MANAGEMENT
		if ( $state.params['year'] ) {
			$stateParams.year = $state.params['year'];
			$rootScope.year = $state.params['year'];
		} else if ( !$rootScope.year ) {
			if ( $state.current !== 'app.event.years' ) {
				$state.go('app.event.years');
			}
		}
		// else {
		// 	console.log('nothing');
		// }
	}

	$scope.updateStateYear();

})




.controller('ModalLocationInstanceController', function ($scope, $uibModalInstance, LocationCreateService) {

	$scope.marker = null;
	$scope.locationData = {
		name: '',
		address: '',
		latitude: '',
		longitude: '',
		route_description: ''
	};

	$scope.map = {
		center: { latitude: 41.9099856, longitude: 12.3955726 },
		options: {
			streetViewControl: false,
			fullscreenControl: false,
			mapTypeControl: false
		},
		zoom: 7,
		events: {
			click: function (map, eventName, originalEventArgs) {
				var e = originalEventArgs[0];
				$scope.geocodePosition(e);
				var lat = e.latLng.lat(),
					lng = e.latLng.lng();
				$scope.marker = {
					id: Date.now(),
					coords: {
						latitude: lat,
						longitude: lng
					}
				};
				$scope.map.center = { latitude: lat, longitude: lng };
				$scope.$apply();
			}
		}
	};

	$scope.geocoding = false;
	$scope.geocoder = new google.maps.Geocoder();
	$scope.geocodePosition = function(event) {
		$scope.geocoding = true;

		$scope.locationData.latitude = event.latLng.lat();
		$scope.locationData.longitude = event.latLng.lng();

		$scope.geocoder.geocode({
			latLng: event.latLng
		}, function(responses) {

			$scope.geocoding = false;
			if (responses && responses.length > 0) {
				$scope.locationData.address = responses[0].formatted_address;
			}

			$scope.$apply();
		});
	};


	$scope._saveLocation = function()
	{
		LocationCreateService
			.create( $scope.locationData )
			.then(function(data) {
				$scope.hideLoader();

				$uibModalInstance.close( data );
				$scope.showSuccessMsg('Location aggiunta con successo!', '');
			});
	};


	$scope.saveLocation = function () {
		$scope.showLoader();

		if ( !$scope.locationData.latitude && !$scope.locationData.longitude ) {
			$scope.geocoder.geocode({
				address: $scope.locationData.address
			}, function(responses) {
				if (responses && responses.length > 0) {
					$scope.locationData.latitude  = responses[0].geometry.location.lat();
					$scope.locationData.longitude = responses[0].geometry.location.lng();
					$scope._saveLocation();
				}
			});
		} else {
			$scope._saveLocation();
		}
	};

	$scope.closeModal = function() {
		$uibModalInstance.dismiss('cancel');
	};

});